<template>
  <div>
    <div class="desktop" style="margin-top: 67px; padding-left: 30px; padding-right: 30px;">
      <div class="cash-head-title">
        <h1>I/O Cash 알아보기</h1>
      </div>
      <section class="cash-hero">
        <div class="title">
          <h1>I/O 제품을 가장 저렴하게 쓰는 방법.</h1>
          <p>
            아이오 캐시는 아이오에서 통용되는 화폐입니다.
            <br>여타의 포인트, 적립 시스템과 차별화된 아이오만의 실용적인 방식을 제안합니다.
            <br>
          </p>
        </div>
      </section>
      <section class="cash-description">
        <div class="title">
          <h1>I/O Cash 얻는법</h1>
        </div>
        <div class="cash-description-wrapper-third">
          <div class="cash-description-container-howto">
            <h1>
              ACTION 1.
              <br>프로모션 참여
            </h1>
            <div class="howto-right-container">
              <p style="color: #6f97fa; margin: 0;">*각 제품 20%할인 혜택</p>
              <p style="color: #6f97fa; margin: 0;">*무료체험 후 결제일에 아이오 캐시로 결제됩니다.</p>
              <p style="color: #6f97fa; margin: 0;">*프로모션에 참여해서 캐시를 적립해두면 결제일에 0원이 결제!</p>
              <div class="cash-meet-funding">
                <h1>
                  <span style="font-size: 15px;">우리집 방범 지키미</span>
                  <br>
                  <span class="bold">Checker</span> 더 싸게 만나보실래요?
                </h1>
                <p
                  style="margin-top: 33px; margin-bottom: 2px; font-size: 11px;"
                >* I/O Cash를 이용하여 20% 더 저렴한 가격에 만나보세요</p>
                <button @click="goCheckerFunding">프로모션 보기</button>
              </div>
            </div>
          </div>
          <div class="cash-description-container-howto">
            <h1>
              ACTION 2.
              <br>아이오 제품 추천
            </h1>
            <div class="howto-right-container">
              <p style="margin: 0;">
                가족, 친구, 직장 동료에게 아이오 제품 추천하고, 추천 받은 사람이 구매하지 않아도
                <br>한 달 무료 체험을 신청만 하면, 제품 금액의 20%가 캐시로 자동 적립
              </p>
              <!-- <img
                style="margin-top: 20px; width: 100%;"
                src="@/assets/cash/cash-viral-step.png"
                alt
              > -->
            </div>
          </div>
          <div class="cash-description-container-howto">
            <h1>
              ACTION 3.
              <br>인스타 업로드 이벤트
            </h1>
            <div class="howto-right-container">
              <p style="margin: 0;">
                아이오 제품을 받아보시고 인스타를 팔로우 하신 뒤 인스타에 아이오 제품과
                <br>홈 스타일링해서 찍으신 사진을 아래 태그들과 함께 사진을 올려주시면
                <br>아이오 캐시 5,000원을 드립니다.
              </p>
              <p style="color: #6f97fa; margin: 0;">*아이오 인스타: @smarthome_io 해시 태그: #아이오 #스위처 #링커 #체커 #스마트홈</p>
              <p style="color: #6f97fa; margin: 0;">*한 제품 당 한 번의 리뷰만 참여가 가능합니다.</p>
              <p style="color: #6f97fa; margin: 0;">
                *
                <a href="https://www.instagram.com/smarthome_io/">아이오 인스타</a> DM으로 인증해주세요.
              </p>
              <p style="color: #6f97fa; margin: 0;">*비공개 계정은 제외됩니다.</p>
              <img
                style="margin-top: 20px; width: 100%"
                src="@/assets/cash/cash-follow-step.png"
                alt
              >
            </div>
          </div>
          <div
            style="margin-top: 20px; width: 100%; height: 2px; background-color: #dee2e5; margin:45px auto;"
          ></div>

        </div>
        <div class="title">
          <h1>I/O Cash 는</h1>
        </div>
        <div class="cash-description-wrapper">
          <div class="cash-description-container">
            <img src="@/assets/cash/cash-img-1.png" alt>
            <h1>I/O Cash, 단위는 원</h1>
            <p>
              아이오 캐시 1원은
              <br>한화 1원에 환원합니다.
            </p>
          </div>
          <div class="cash-description-container">
            <img src="@/assets/cash/cash-img-2.png" alt>
            <h1>사용 제약이 없습니다</h1>
            <p>
              최소 사용금액, 적립 최대 금액,
              <br>결제액 일부 제한 등 어떠한 조건없이,
              <br>원하는 시점에 언제든
              <br>1원부터 사용 가능합니다.
            </p>
          </div>
          <div class="cash-description-container">
            <img src="@/assets/cash/cash-img-3.png" alt>
            <h1>소멸되지 않습니다</h1>
            <p>
              아이오 캐시는 사용기간이 없습니다.
              <br>1년이든, 10년이든 그대로 유지됩니다.
            </p>
          </div>
        </div>
      </section>

      <section class="freetrial-suggestion">
        <div class="title">
          <h1>자, 어떤 제품을 체험해볼까요?</h1>
        </div>
        <div class="suggestion-wrapper">
          <div class="switcher">
            <h2>Switcher</h2>
            <span>누워서 불을 끄는 가장 심플한 방법</span>
            <button @click="goProduct(1)">제품보기</button>
          </div>
        </div>
        <div class="suggestion-wrapper">
          <div class="linker">
            <h2>Linker</h2>
            <span>우리 집 만능리모컨</span>
            <button @click="goProduct(3)">제품보기</button>
          </div>
        </div>
      </section>
    </div>
    <div class="mobile" style="margin-top: 63px;">
      <section class="cash-first">
        <h1>I/O 캐시란?</h1>
        <div>
          <span>제품 구매용 포인트로
            <br>아래처럼 공짜로 얻을 수 있습니다.</span>
        </div>
      </section>
      <section class="cash-second">
        <div class="title">
          <h1>I/O 캐시 얻는 법</h1>
        </div>
        <div class="cash-feature">
          <h1>ACTION 1. 프로모션 참여</h1>
          <p>
            아이오 신제품 런칭 시, 프로모션 참여 하여
            <br>약 1.5배로 I/O 캐시 받기
          </p>
              <p style="color: #6f97fa; margin: 0;">*무료체험 중인 제품 20%할인 혜택 </p>
              <p style="color: #6f97fa; margin: 0;">*무료체험 후 결제일에 아이오 캐시로 결제됩니다.</p>
              <p style="color: #6f97fa; margin: 0;">*프로모션에 참여해서 캐시를 적립해두면 결제일에 0원이 결제!</p>
          <div class="m-cash-meet-funding">
            <div>
              <p
                style="margin-top: 20px; margin-bottom: 2px; font-size: 11px; letter-spacing: -1px;"
              >* I/O Cash를 이용하여 20% 더 저렴한 가격에 만나보세요</p>
              <button @click="goCheckerFunding">프로모션 보기</button>
            </div>
          </div>
        </div>
        <div class="cash-feature">
          <h1>ACTION 2. 아이오 제품 추천</h1>
          <p>
            친구가 무료체험 신청할 때 내 전화번호를 입력하면
            <br>제품가격의 20%가 캐시로 적립.
          </p>
          <!-- <div style="width: 100%; text-align: center;">
            <img
              style="margin-top: 20px; width: 100%;"
              src="@/assets/cash/m-cash-recommend.png"
              alt
            >
          </div> -->
        </div>
        <div class="cash-feature">
          <h1>ACTION 3. 인스타 업로드 이벤트</h1>
          <p>
            <a href="https://www.instagram.com/smarthome_io/">인스타</a> 팔로우 후
            <br>아이오 제품을 찍으신 사진을
            <br>아래 태그들과 함께 올려주시면
            <br>Cash 5,000원을 드립니다.
          </p>
          <p style="color: #6f97fa; margin: 0;">*아이오 인스타: @smarthome_io</p>
          <p style="color: #6f97fa; margin: 0;">*해시 태그: #아이오, #스위처, #링커, #체커, #스마트홈</p>
          <p style="color: #6f97fa; margin: 0;">
            *<a href="https://www.instagram.com/smarthome_io/">아이오 인스타</a> DM으로 인증해주세요.
          </p>
          <p style="color: #6f97fa; margin: 0;">*한 제품 당 한 번의 리뷰만 이벤트 참여가 가능합니다.</p>

          <p style="color: #6f97fa; margin: 0;">*비공개 계정은 제외됩니다.</p>
          <a href="https://www.instagram.com/smarthome_io/"><img
            style="margin-top: 20px; width: 100%;"
            src="@/assets/cash/m-cash-insta.png"
            alt
          ></a>
        </div>
        <h1 style="margin-top: 80px;">I/O 캐시는</h1>
        <div class="cash-description-container width-100 margin-top-bottom-10">
          <img src="@/assets/cash/cash-img-2.png" alt>
          <h1>사용 제약이 없습니다</h1>
          <p>
            최소 사용금액, 적립 최대 금액,
            <br>결제액 일부 제한 등 어떠한 조건없이,
            <br>원하는 시점에 언제든
            <br>1원부터 사용 가능합니다.
          </p>
        </div>
        <div class="cash-description-container width-100 margin-top-bottom-10">
          <img src="@/assets/cash/cash-img-3.png" alt>
          <h1>소멸되지 않습니다</h1>
          <p>
            아이오 캐시는 사용기간이 없습니다.
            <br>1년이든, 10년이든 그대로 유지됩니다.
          </p>
        </div>
      </section>
      <section class="freetrial-third">
        <h1>자, 어떤 제품을 체험해볼까요?</h1>
        <div class="recommend-product" id="switcher" style="margin-top: 22px;">
          <span>Switcher</span>
          <p>
            누워서 불을 끄는
            <br>가장 심플한 방법
          </p>
          <router-link :to="{ name: 'Switcher' }">
            <button>제품보기</button>
          </router-link>
        </div>
        <div class="recommend-product" id="linker">
          <span>Linker</span>
          <p>우리 집 만능리모컨</p>
          <router-link :to="{ name: 'Linker' }">
            <button>제품보기</button>
          </router-link>
        </div>
      </section>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import AppFooter from './AppFooter'
import {IO_PRODUCTS} from '../modules/products.js'
const alertOptions = {title: '', size: 'sm', okLabel: '확인'}

export default {
  name: 'free-trial',
  components: {AppFooter},
  methods: {
    goProduct: function (productId) {
      switch (productId) {
        case IO_PRODUCTS.SWITCHER_ONE_BUTTON:
          this.$router.push({ name: 'Switcher' })
          break
        case IO_PRODUCTS.LINKER:
          this.$router.push({ name: 'Linker' })
          break
      }
    },
    goCheckerFunding: function () {
      this.$dialogs.alert('준비 중입니다.', alertOptions)
      // this.$router.push({ name: 'Promotion' })
    }
  }
}
</script>
<style scoped>

.cash-head-title {
  background-color: #ffffff;
  height: 60px;
  text-align: left;
  padding: 20px 0px 0px 0px;
}
.cash-hero {
  text-align: left;
  display: flex;
  align-items: center;
}
.cash-hero .title {
  margin-left: 10%;
}
.cash-hero h1 {
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
}
.cash-hero p {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.57;
  color: #ffffff;

}
.cash-head-title h1 {
  font-size: 20px;
  font-weight: bold;
}
.cash-hero {
  background: url("../assets/cash/cash-hero.png") no-repeat center center;
  background-size: cover;
  min-height: 452px;
}

.cash-description .title {
  margin-top: 100px;
  margin-bottom: 100px;
}
.cash-description .title h1 {
  font-size: 24px;
}

.cash-description-wrapper {
  display: flex;
  justify-content: space-between;
  width: 65%;
  margin: 0 auto;
}

.cash-description-wrapper-second {
  display: flex;
  justify-content: space-between;
  width: 65%;
  margin: 0 auto;
  margin-top: 18px;
}
.cash-description-wrapper-third {
  width: 65%;
  margin: 0 auto;
}

.cash-description-wrapper-second .cash-description-container {
  width: 49%;
  height: 310px;
  background-color: #fafafa;
}

.cash-description-container {
  padding: 30px;
  width: 32%;
  height: 310px;
  background-color: #fafafa;
}

.cash-description-container img {
  width: 100px;
  height: 100px;
}

.cash-description-container h1 {
  font-size: 14px;
  font-weight: bold;
}
.cash-description-container p {
  font-size: 14px;
  line-height: 1.57;
}

.cash-description-container-howto {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.cash-description-container-howto h1 {
  font-size: 20px;
  font-weight: normal;
  line-height: 1.5;
  text-align: left;
}

.m-cash-meet-funding {
  text-align: center;
  padding: 25px;
  margin-top: 25px;
}

.m-cash-meet-funding div {
  font-size: 25px !important;
  line-height: 1.35;
}
.cash-meet-funding {
  background: url("../assets/cash/cash-meet-funding.png") no-repeat center center;
  background-size: cover;
  min-height: 168px;
  text-align: left;
  padding: 25px;
  margin-top: 50px;
}

.cash-meet-funding h1 {
  font-size: 20px;
  font-weight: normal;
  margin: 0px;
  line-height: 1;
}

.m-cash-meet-funding button {
  width: 250px;
  height: 50px;
  text-decoration: none;
  background-color: transparent;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  color: #3d4953;
  cursor: pointer;
  font-size: 20px;
}

@media (max-width: 320px) {
  .m-cash-meet-funding button {
    width: 200px;
    font-size: 18px;
  }
  }

.cash-meet-funding button {
  width: 170px;
  height: 30px;
  text-decoration: none;
  background-color: transparent;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  color: #3d4953;
  cursor: pointer;
  font-size: 14px;
}

.howto-right-container {
  width: 65%;
  text-align: left;
  font-size: 16px;
  line-height: 1.62;
}
.right-descrition {
  width: 50%;
  text-align: left;
}
.right-descrition h2 {
  font-size: 16px;
  font-weight: bold;
}
.right-descrition p {
  font-size: 16px;
  font-weight: 400;
}
.freetrial-suggestion .title {
  margin-top: 100px;
  margin-bottom: 45px;
}
.freetrial-suggestion .title h1{
  font-size: 20px;
}

.suggestion-wrapper {
  margin-top: 10px;
}
.suggestion-wrapper .switcher {
  background: url("../assets/free-trial/suggestion-switcher.png") no-repeat center center;
  background-size: cover;
  min-height: 260px;
  max-width: 1024px;
  margin: 0 auto;
  padding: 67px 0px 0px 105px;
  text-align: left;
}
.suggestion-wrapper .linker {
  background: url("../assets/free-trial/suggestion-linker.png") no-repeat center center;
  background-size: cover;
  min-height: 260px;
  max-width: 1024px;
  margin: 0 auto;
  padding: 67px 0px 0px 105px;
  text-align: left;
  margin-bottom: 120px;
}
.suggestion-wrapper h2 {
  font-size: 20px;
  font-weight: bold;
}
.suggestion-wrapper span {
  display: block;
  font-size: 18px;
}
.suggestion-wrapper button {
  margin-top: 27px;
  width: 94px;
  height: 39px;
  text-decoration: none;
  background-color: transparent;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  color: #3d4953;
  cursor: pointer;
}

.suggestion-wrapper button:hover {
  border: solid 1px #3d4953;
}
/* mobile */
.cash-first {
  background: url("../assets/cash/m-cash.png") no-repeat center center;
  background-size: cover;
  min-height: 469px;
  text-align: left;
  padding: 41px 0px 0px 26px;
}
.cash-first h1 {
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
}
.cash-first div {
  margin-top: 23px;
}
.cash-first span {
  margin-top: 23px;
  font-size: 18px;
  color: #ffffff;
}
.cash-first p {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.71;
  color: #ffffff;
}
.cash-second {
  text-align: center;
  padding: 30px;
}
.cash-second h1 {
  font-size: 18px;
  font-weight: bold;
}

.width-100 {
  width: 100%;
}
.margin-top-bottom-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.cash-instruction-container {
  background-color: #fafafa;
  width: 100%;
  min-height: 310px;
}

.cash-feature {
  text-align: left;
  border-bottom: solid 1px #dee2e5;
  margin-top: 35px;
  padding-bottom: 35px;
}

.cash-feature h1 {
  font-size: 14px;
  font-weight: bold;
}
.cash-feature p {
  font-size: 14px;
}
.freetrial-third h1 {
  font-size: 18px;
  font-weight: bold;
}
#switcher {
  background: url("../assets/free-trial/freetrial-switcher.png") no-repeat center bottom;
  background-size: cover;
  min-height: 352px;
}
#linker {
  background: url("../assets/free-trial/freetrial-linker.png") no-repeat center center;
  background-size: cover;
  min-height: 352px;
}

.recommend-product {
  text-align: left;
  padding: 47px 0px 0px 28px;
}
.recommend-product span {
  font-size: 16px;
  font-weight: bold;
}
.recommend-product p {
  font-size: 16px;
  line-height: 1.62;
  margin-top: 10px;
}

.recommend-product button {
  width: 94px;
  height: 39px;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  background-color: transparent;
  margin-top: 27px;
  color: #3d4953;
  font-size: 14px;
}
.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Cash.vue